// user add
export const ADD_USER_LOADING = "user/add/laoding";
export const ADD_USER_SUCCESS = "user/add/success";
export const ADD_USER_ERROR = "user/add/error";
//get user
export const GET_USER_LOADING = "user/get/laoding";
export const GET_USER_SUCCESS = "user/get/success";
export const GET_USER_ERROR = "user/get/error";

// REMOVE user
export const REMOVE_USER_LOADING = "user/remove/laoding";
export const REMOVE_USER_SUCCESS = "user/remove/success";
export const REMOVE_USER_ERROR = "user/remove/error";

// set user data after login
export const LOGIN_SET_USER_DATA = "login/userdata/set";
export const LOGIN_GET_USER_DATA = "login/userdata/get";
export const LOGIN_REMOVE_USER_DATA = "login/userdata/remove";

export const REMOVE_USERAdmin_LOADING = "useradmin/remove/laoding";
export const REMOVE_USERAdmin_SUCCESS = "useradmin/remove/success";
export const REMOVE_USERAdmin_ERROR = "useradmin/remove/error";
